import { render, staticRenderFns } from "./StudentGeneralInformation.vue?vue&type=template&id=0f302cc6"
import script from "./StudentGeneralInformation.vue?vue&type=script&lang=js"
export * from "./StudentGeneralInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports